import { render } from "./WorkListSkeleton.vue?vue&type=template&id=2918ef61&scoped=true&ts=true"
import script from "./WorkListSkeleton.vue?vue&type=script&lang=ts"
export * from "./WorkListSkeleton.vue?vue&type=script&lang=ts"

import "./WorkListSkeleton.vue?vue&type=style&index=0&id=2918ef61&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2918ef61"]])

export default __exports__